<template>
  <div class="forget-box" v-if="forgetPwdShow">
    <div class="forget">
      <img @click="closeForgetBox" class="pic-close" src="../assets/images/close.png" />
      <img class="pic" src="../assets/images/login-left.png" />
      <div class="login-right">
        <div class="title">密码重置</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :show-message="false">
            <el-form-item prop="tel" class="form-item">
              <div class="input-box">
                <div v-if="labelTip[0].tip" @click="tipClickHandler(0)" class="phone-tip">手机号</div>
                <div v-else class="label-title">手机号</div>
                <el-input v-model="ruleForm.tel" name="tel" ref="input0" @blur="inputBlur(0)"  @focus="inputFocus(0)"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="authCode" class="form-item">
              <div class="input-box">
                <div v-if="labelTip[1].tip" @click="tipClickHandler(1)" class="phone-tip">验证码</div>
                <div v-else class="label-title">验证码</div>
                <el-input v-model="ruleForm.authCode" ref="input1" @blur="inputBlur(1)"  @focus="inputFocus(1)"></el-input>
                <div v-if="showGetCode" @click="getCodeHandler" class="get-code get-code-cur">获取验证码</div>
                <div v-else class="get-code re-get-code">重新获取({{codeTimeCut}})</div>
              </div>
            </el-form-item>
            <el-form-item prop="pwd" class="form-item">
              <div class="input-box">
                <div v-if="labelTip[2].tip" @click="tipClickHandler(2)" class="phone-tip">新密码</div>
                <div v-else class="label-title">新密码（不少于6位数（数字+字母））</div>
                <el-input type="password" v-model="ruleForm.pwd" ref="input2" @blur="inputBlur(2)"  @focus="inputFocus(2)"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="pwd2" class="form-item-code">
              <div class="input-box">
                <div v-if="labelTip[3].tip" @click="tipClickHandler(3)" class="phone-tip">确认密码</div>
                <div v-else class="label-title">确认密码</div>
                <el-input type="password" v-model="ruleForm.pwd2" ref="input3" @blur="inputBlur(3)"  @focus="inputFocus(3)"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button class="login-button" type="primary" round @click="restHandler">重置</el-button>
            </el-form-item>
          </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { login, getCode, resetPwd } from '../server/me';
  import { setCookie } from '../utils/utils';
  import { mapGetters } from 'vuex';
  export default {
    name: 'mlogin',
    props: {
      forgetPwdShow: {
        type: Boolean,
        default: false
      },
    },
    data () {
      const handleConfirmPassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }

      return {
        timer: '',
        showGetCode: true,
        codeTimeCut: 60,
        ruleForm: {
          tel: "",
          authCode: "",
          pwd: "",
          pwd2: ""
        },
        rules: {
          tel: [
            { required: true, message: '请输入手机' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确' },
          ],
          authCode: [
            { required: true, message: '请输入手机验证码' },
            { pattern: /^\d{4,6}$/, message: '手机验证码格式不正确' },
          ],
          pwd: [
            { type: 'string', required: true, message: '请输入密码' },
            { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{1,}$/, message: '密码数字加字母' },
            { min: 6, max: 12, message: '密码位数6-12位' }
          ],
          pwd2: [
            { validator: handleConfirmPassword, trigger: 'blur' },
          ]
        },
        labelTip: [
          { tip: true },
          { tip: true },
          { tip: true },
          { tip: true },
        ]
      }
    },
    inject: ['reload'],
    computed: {
      ...mapGetters([
        'isShowLogin'
      ])
    },
    methods: {
      closeForgetBox() {
        this.$emit('closeResetodal');
      },
      getCodeHandler() {
        this.$refs['ruleForm'].validateField("tel", (errorMessage) => {
          if (errorMessage) {
            this.$message({
              center: true,
              message: errorMessage,
              type: 'error',
              duration: "1000"
            });
          } else {
            this.showGetCode = false;
            this.getMobileCode();
            this.timer = setInterval(() => {
              this.codeTimeCut --;
              if (this.codeTimeCut <= 0) {
                this.codeTimeCut = 60;
                this.showGetCode = true;
                clearInterval(this.timer);
              }
            }, 1000);
          }
        });
      },
      inputFocus(number) {
        this.labelTip[number].tip = false;
      },
      inputBlur(number) {
        const arr = Object.keys(this.ruleForm);
        const key = arr[number];
        if (this.ruleForm[key]) {
          this.labelTip[number].tip = false;
        } else {
          this.labelTip[number].tip = true;
        }
      },
      tipClickHandler(number) {
        const _this = this;
        _this.labelTip[number].tip = false;
        const input = `input${number}`;
        setTimeout(function() {
          _this.$nextTick(() => {
            _this.$refs[input].focus()
          })
        }, 0);
      },
      async getMobileCode() {
        const obj = {
          tel: this.ruleForm.tel,
          type: 3
        };
        const { code = 1, msg = '' } = await getCode(obj);
        if (code === 0) {
          this.$message({
            message: msg,
            type: "success"
          });
        } else {
          this.$message.error(msg);
        }
      },
      restHandler() {
        this.$refs['ruleForm'].validate((valid, obj) => {
          if (valid) {
            this.resetPwdHandler()
          } else {
            let status = true;
            Object.keys(this.ruleForm).map((key) => {
              this.$refs['ruleForm'].validateField(key, (errorMessage) => {
                if (errorMessage && status) {
                  status = false;
                  this.$message({
                    center: true,
                    message: errorMessage,
                    type: 'error',
                  });
                  return;
                }
              })
            });
          }
        })
      },
      async resetPwdHandler() {
        const { code = 1, msg = '' } = await resetPwd(this.ruleForm);
        if (code === 0) {
          this.$emit('resetPwdSuccess');
          this.$message({
            message: "重置密码成功",
            type: "success"
          });
          setTimeout(() => {
            this.$store.dispatch('user/openLogin', true);
          }, 1000)
        } else {
          this.$message.error(msg);
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./scss/forget.scss"></style>
<style lang="scss" src="./scss/login-variables.scss"></style>


// WEBPACK FOOTER //
// src/components/forget.vue